import { API } from '../api';
import axiosInstance from '../axiosConfig';

export const updateCard = async (payload) => {
  const response = await axiosInstance.post(`${API.SUBSCRIPTIONS.UPDATE_CARD}`, payload);
  return response.data;
};
export const enablePlanOnSlot = async ({ planId, slotType }) => {
  const response = await axiosInstance.get(
    `${API.SUBSCRIPTIONS.SELECT_PLAN_FOR_SLOT}/${planId}/${slotType}`
  );
  return response.data;
};

export const getUserPlan = async (id) => {
  const response = await axiosInstance.get(`${API.SUBSCRIPTIONS.GET_USER_PLAN}/${id}`);
  return response.data;
};

export const getUserCard = async (id) => {
  const response = await axiosInstance.get(`${API.SUBSCRIPTIONS.GET_USER_CARD}/${id}`);
  return response.data;
};

export const toggleSquarePlanStatus = async (planId, isActive) => {
  const response = await axiosInstance.patch(
    `${API.SUBSCRIPTIONS.SQUARE_PLAN_STATUS_UPDATE}/${planId}/${isActive}`
  );
  return response.data;
};

export const createSquareVariation = async (payload) => {
  const response = await axiosInstance.post(`${API.SUBSCRIPTIONS.SQUARE_PLAN_VARAITION}`, payload);
  return response.data;
};

export const createPlan = async (payload) => {
  const response = await axiosInstance.post(`${API.SUBSCRIPTIONS.ADD_PLAN}`, payload);
  return response.data;
};
export const getPlans = async () => {
  const response = await axiosInstance.get(`${API.SUBSCRIPTIONS.GET_PLAN}`);
  return response.data;
};
export const deletePlan = async (planId) => {
  const response = await axiosInstance.delete(`${API.SUBSCRIPTIONS.DELETE_PLAN}/${planId}`);
  return response.data;
};
export const updatePlan = async (payload) => {
  const response = await axiosInstance.patch(`${API.SUBSCRIPTIONS.UPDATE_PLAN}`, payload);
  return response.data;
};

export const getSubScriptions = async () => {
  const response = await axiosInstance.get(`${API.SUBSCRIPTIONS.GET}`);
  return response.data;
};
export const getSubScriptionsFeatures = async () => {
  const response = await axiosInstance.get(`${API.SUBSCRIPTIONS.FEATURE_LIST}`);
  return response;
};
export const upgradeSubscription = async (payload) => {
  const response = await axiosInstance.post(`${API.SUBSCRIPTIONS.UPGRADE_SUB_PLAN}`, payload);
  return response;
};

export const updateSubScriptions = async (payload) => {
  const response = await axiosInstance.patch(`${API.SUBSCRIPTIONS.UPDATE}`, payload);
  return response;
};
